import { motion } from "framer-motion";

const STRIP = [
  {
    img: "https://images.unsplash.com/photo-1636138100319-0eb45791963e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxkZXNlcnQlMjBkdW5lJTIwc3Vuc2V0JTIwb3ZlcmxhbmR8ZW58MHx8fHwxNzg4ODk4Mzg4fDA&ixlib=rb-4.1.0&q=85",
    label: "ERG CHEBBI",
  },
  {
    img: "https://images.unsplash.com/photo-1771186936875-f80e00ec1127?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxkZXNlcnQlMjBkdW5lJTIwc3Vuc2V0JTIwb3ZlcmxhbmR8ZW58MHx8fHwxNzg4ODk4Mzg4fDA&ixlib=rb-4.1.0&q=85",
    label: "BARDENAS REALES",
  },
  {
    img: "https://images.unsplash.com/photo-1605019659411-f6dd1d229f0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxvdmVybGFuZCUyMGNhbXBpbmclMjA0eDQlMjBleHBlZGl0aW9ufGVufDB8fHx8MTc4ODg5ODM3OHww&ixlib=rb-4.1.0&q=85",
    label: "ALPI GIULIE",
  },
  {
    img: "https://images.unsplash.com/photo-1672334440489-7945a743b823?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxvZmZyb2FkJTIwNHg0JTIwZGVzZXJ0JTIwbXVkfGVufDB8fHx8MTc4ODg5ODM3OHww&ixlib=rb-4.1.0&q=85",
    label: "VAL D'ORCIA",
  },
];

export default function PhotoStrip() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 border-t border-line" data-testid="photo-strip">
      {STRIP.map((s, i) => (
        <motion.figure
          key={i}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: i * 0.08 }}
          className="relative h-[200px] sm:h-[260px] overflow-hidden group border-r border-line last:border-r-0"
        >
          <img
            src={s.img}
            alt={s.label}
            loading="lazy"
            className="w-full h-full object-cover warm-grade group-hover:scale-105 transition-transform duration-700"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <figcaption className="absolute bottom-3 left-3 font-telemetry text-[9px] tracking-[0.22em] uppercase text-sand opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            {s.label}
          </figcaption>
        </motion.figure>
      ))}
    </div>
  );
}
